import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { AuthGuard } from './shared/auth/auth-guard.service';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () => import('./layouts/full/full-layout.component').then(m => m.FullLayoutComponent),
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/home/home.routes').then(m => m.routes)
      },
      {
        path: 'dvr',
        loadChildren: () => import('./pages/dvr/dvr.routes').then(m => m.routes)
      },
      {
        path: 'rivenditori',
        loadChildren: () => import('./pages/rivenditori/rivenditori.routes').then(m => m.routes)
      },
      {
        path: 'utenti',
        loadChildren: () => import('./pages/utenti/utenti.routes').then(m => m.routes)
      },
      {
        path: 'news',
        loadChildren: () => import('./pages/news/news.routes').then(m => m.routes)
      },
      {
        path: 'informative',
        loadChildren: () => import('./pages/informative/informative.routes').then(m => m.routes)
      },
      {
        path: 'dichiarazioni',
        loadChildren: () => import('./pages/dichiarazioni/dichiarazioni.routes').then(m => m.routes)
      },
      {
        path: 'licenze',
        loadChildren: () => import('./pages/licenze/licenze.routes').then(m => m.routes)
      },
      {
        path: 'tipilicenze',
        loadChildren: () => import('./pages/tipi-licenze/tipi-licenze.routes').then(m => m.routes)
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/settings-page/settings-page.component').then(m => m.SettingsPageComponent)
      },
      {
        path: 'license',
        loadComponent: () => import('./pages/license-page/license-page.component').then(m => m.LicensePageComponent)
      }
    ],
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard]
  },
  { path: 'login', loadComponent: () => import('./pages/login-page/login-page.component').then(m => m.LoginPageComponent) },
  { path: 'register', loadComponent: () => import('./pages/register-page/register-page.component').then(m => m.RegisterPageComponent) },
  { path: 'forgotpassword', loadComponent: () => import('./pages/forgot-password-page/forgot-password-page.component').then(m => m.ForgotPasswordPageComponent) },
  { path: 'resetpassword', loadComponent: () => import('./pages/reset-password-page/reset-password-page.component').then(m => m.ResetPasswordPageComponent) },
  { path: 'error', loadComponent: () => import('./pages/error-page/error-page.component').then(m => m.ErrorPageComponent) },
  { path: '**', loadComponent: () => import('./pages/not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent) },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})

export class AppRoutingModule {

}
